import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FieldValidation } from '@atlassian/mpac-utils';

/*
 The validations added here are in sync with backend validations
 1. https://bitbucket.org/atlassian-marketplace/amkt/src/master/webapp/src/main/scala/com/atlassian/marketplace/http/VendorFieldValidation.scala#lines-70
 2. https://bitbucket.org/atlassian-marketplace/amkt/src/master/webapp/src/main/scala/com/atlassian/marketplace/http/VendorFieldValidation.scala#lines-48
*/
const {
  checkNonEmptyAlphanumeric,
  checkNonEmptyString
} = FieldValidation;
const excludedAccentedCharsRegex = /[ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝßàáâäåæçèéêëìíîïðñòóôõöøùúûüýÿĀāąćčĒėĘęĞğĪīĮįİıŁłŃńŌōœŚśŞşŠšŪūŸźŻżŽžǹḕ]/;
/*
  checks the field value to contain:
  1. not contain accented characters
  2. not start with a special character
  3. not contain '*+:~:
*/

export const checkOptionalVendorPaymentField = name => value => {
  const trimmedValue = (value !== null && value !== void 0 ? value : '').trim();

  if (trimmedValue.match(excludedAccentedCharsRegex) !== null) {
    return "".concat(name, " cannot include accented characters");
  }

  if (trimmedValue && trimmedValue.match(/^[\dA-Za-z]/) == null) {
    return "".concat(name, " cannot start with a special character");
  }

  if (trimmedValue.match(/['*+:~]/) !== null) {
    return "".concat(name, " can not contain the following characters ' * + : ~");
  }
};
/*
  checks the field value to contain:
  1. have non-empty alphanumeric string
  2. not contain accented characters
*/

export const checkPostCodeField = name => value => {
  const trimmedValue = (value !== null && value !== void 0 ? value : '').trim();
  const nonEmptyAlphanumericCheck = checkNonEmptyAlphanumeric(name)(trimmedValue);

  if (nonEmptyAlphanumericCheck) {
    return nonEmptyAlphanumericCheck;
  }

  if (trimmedValue.match(excludedAccentedCharsRegex) !== null) {
    return "".concat(name, " cannot include accented characters");
  }
};
/*
  checks the field value to contain:
  1. not be a blank string
  2. checks against checkOptionalVendorPaymentField
*/

export const checkNonEmptyVendorPaymentField = name => value => {
  return checkNonEmptyString(name)(value) || checkOptionalVendorPaymentField(name)(value);
};
/*
  The fields would have to be sent as null when empty, in sync with older rules.
  https://bitbucket.org/atlassian-marketplace/amkt/src/master/webapp/src/main/javascript/js/amkt/vendor-payment-details/models/vendor-payment-details-model.js#lines-34
 */

export const getUpdatePaymentDetailsPayload = (fields, _links) => {
  var _fields$intermediaryB, _fields$intermediaryB3, _fields$bankAccountTy, _fields$routingNumber, _fields$swiftCode, _fields$localBankId, _fields$specialHandli;

  let paymentFields = {
    accountName: fields.accountName.trim(),
    accountNumberOrIban: fields.accountNumberOrIban.trim(),
    bankName: fields.bankName.trim(),
    bankCity: fields.bankCity.trim(),
    bankState: fields.bankState.trim(),
    bankIsoCountryCode: fields.bankCountry.abbr.trim(),
    bankAddress: fields.bankAddress.trim(),
    bankPincode: fields.bankPincode.trim()
  };

  if ((_fields$intermediaryB = fields.intermediaryBankId) !== null && _fields$intermediaryB !== void 0 && _fields$intermediaryB.trim()) {
    var _fields$intermediaryB2;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      intermediaryBankId: (_fields$intermediaryB2 = fields.intermediaryBankId) === null || _fields$intermediaryB2 === void 0 ? void 0 : _fields$intermediaryB2.trim()
    });
  }

  if ((_fields$intermediaryB3 = fields.intermediaryBankName) !== null && _fields$intermediaryB3 !== void 0 && _fields$intermediaryB3.trim()) {
    var _fields$intermediaryB4;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      intermediaryBankName: (_fields$intermediaryB4 = fields.intermediaryBankName) === null || _fields$intermediaryB4 === void 0 ? void 0 : _fields$intermediaryB4.trim()
    });
  }

  if ((_fields$bankAccountTy = fields.bankAccountType) !== null && _fields$bankAccountTy !== void 0 && _fields$bankAccountTy.value.trim()) {
    var _fields$bankAccountTy2;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      bankAccountType: (_fields$bankAccountTy2 = fields.bankAccountType) === null || _fields$bankAccountTy2 === void 0 ? void 0 : _fields$bankAccountTy2.value
    });
  }

  if ((_fields$routingNumber = fields.routingNumber) !== null && _fields$routingNumber !== void 0 && _fields$routingNumber.trim()) {
    var _fields$routingNumber2;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      routingNumber: (_fields$routingNumber2 = fields.routingNumber) === null || _fields$routingNumber2 === void 0 ? void 0 : _fields$routingNumber2.trim()
    });
  }

  if ((_fields$swiftCode = fields.swiftCode) !== null && _fields$swiftCode !== void 0 && _fields$swiftCode.trim()) {
    var _fields$swiftCode2;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      swiftCode: (_fields$swiftCode2 = fields.swiftCode) === null || _fields$swiftCode2 === void 0 ? void 0 : _fields$swiftCode2.trim()
    });
  }

  if ((_fields$localBankId = fields.localBankId) !== null && _fields$localBankId !== void 0 && _fields$localBankId.trim()) {
    var _fields$localBankId2;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      localBankId: (_fields$localBankId2 = fields.localBankId) === null || _fields$localBankId2 === void 0 ? void 0 : _fields$localBankId2.trim()
    });
  }

  if ((_fields$specialHandli = fields.specialHandlingNotes) !== null && _fields$specialHandli !== void 0 && _fields$specialHandli.trim()) {
    var _fields$specialHandli2;

    paymentFields = _objectSpread(_objectSpread({}, paymentFields), {}, {
      specialHandlingNotes: (_fields$specialHandli2 = fields.specialHandlingNotes) === null || _fields$specialHandli2 === void 0 ? void 0 : _fields$specialHandli2.trim()
    });
  }

  let addressFields = {
    line1: fields.line1.trim(),
    city: fields.city.trim(),
    state: fields.state.trim(),
    postCode: fields.postCode.trim(),
    country: fields.country.abbr.trim()
  };

  if (fields.line2) {
    addressFields = _objectSpread(_objectSpread({}, addressFields), {}, {
      line2: fields.line2.trim()
    });
  }

  return _objectSpread(_objectSpread({}, _links && {
    _links
  }), {}, {
    address: addressFields,
    contact: {
      email: fields.email.trim(),
      firstName: fields.firstName.trim(),
      lastName: fields.lastName.trim(),
      phoneNumber: fields.phoneNumber.trim()
    },
    payment: paymentFields,
    tax: {
      abnOrTaxId: fields.abnOrTaxId.trim(),
      isGSTRegistered: fields.isGSTRegistered
    }
  });
};